{
  "brand": {
    "title": "Rejista ya SOR",
    "description": "Kuwezesha usimamizi wa uwazi na ufanisi wa mikopo ya kaboni kwa mustakbal endelevu."
  },
  "support": {
    "title": "Msaada",
    "help_center": "Kituo cha Msaada",
    "contact_support": "Wasiliana na Msaada",
    "submit_ticket": "Wasilisha Tiketi",
    "system_status": "Hali ya Mfumo"
  },
  "legal": {
    "title": "Kisheria",
    "privacy_policy": "Sera ya Faragha",
    "terms_of_service": "Masharti ya Huduma",
    "cookie_policy": "Sera ya Vidakuzi",
    "disclaimer": "Kanushio"
  },
  "connect": {
    "title": "Unganisha"
  },
  "copyright": "© Rejista ya Sovereign Offset. Haki zote zimehifadhiwa."
}